import React, { useState, useEffect, useRef } from 'react';
import DesktopSelector from './DesktopSelector';
import MobileSelector from './MobileSelector';
import SnapsWise from './SnapsWise';

const Audiobook = ({ subject, exerciseHandler }) => {
    console.log(subject, "exercise");
    const [transcripts, setTranscripts] = useState([]);
    const [tabs, setTabs] = useState([]);
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [currentScript, setCurrentScript] = useState(null);
    const [key, setKey] = useState(0);

    const getTranscripts = async (course) => {
        const token = localStorage.getItem("token");
        const outdata = {
            "owner": course.owner,
            "author": course.author,
            'title': course.title,
            'language': course.language,
            "type": course.type
        };
        
        const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/subjects/get-structure`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(outdata),
        });
        
        if (response.ok) {
            const json = await response.json();
            setTranscripts(json);
        }
    };

    useEffect(() => {
        if (transcripts && transcripts.length > 0) {
            setCurrentScript(transcripts[activeTabIndex]);
            setKey(prev => prev + 1);
        }
    }, [activeTabIndex, transcripts]);
    
    useEffect(() => {
        if (subject) {
            getTranscripts(subject);
        }
    }, [subject]);

    useEffect(() => {
        if (transcripts && transcripts.length > 0) {
            const files = transcripts
                .filter(x => "file" in x)
                .map(x => x.file);
            setTabs(files);
            console.log(tabs, "tabs")
        }
    }, [transcripts]);

    const hasMultipleParts = tabs && tabs.length > 1;

    return tabs && tabs.length > 0 && currentScript ? (
        <div className='h-screen w-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-100/30 overflow-hidden flex flex-col relative'>
            {/* Compact Header with Middle Selector */}
            <div className='bg-gradient-to-r from-blue-500/90 to-indigo-600/90 backdrop-blur-sm w-full flex-shrink-0 border-b border-white/20 relative z-30'>
                {/* Desktop: All in one row */}
                <div className='hidden xl:flex items-center justify-between px-3 py-2'>
                    {/* Left: Back Button + Title/Author */}
                    <div className='flex items-center gap-2 flex-1 min-w-0'>
                        <button 
                                className="
                                flex items-center gap-2 text-white
                                px-3 py-2 rounded-xl
                                bg-white/15 hover:bg-white/25
                                border border-white/25
                                shadow-sm shadow-black/10
                                backdrop-blur
                                transition
                                focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70
                                group
                                "                            
                                onClick={() => { exerciseHandler(null) }}      
                            title="Back to Library"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" 
                            className="h-4 w-4 group-hover:-translate-x-0.5 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                            </svg>
                            <span className='text-sm font-semibold tracking-wide'>Library</span>
                        </button>
                        
                        <div className='h-4 w-px bg-white/30'></div>
                        
                        <div className='min-w-0 truncate'>
                            
                            <h1 
                                className='font-semibold text-sm text-white truncate leading-none'
                                title={subject.title}
                            >
                                {subject.title}
                            </h1>
                            <p 
                                className='text-xs text-blue-100/80 truncate mt-0.5'
                                title={`by ${subject.author}`}
                            >
                                by {subject.author}
                            </p>
                        </div>
                    </div>
                    
                    {/* Middle: Desktop Selector with Tab Buttons */}
                    {hasMultipleParts && (
                        <div className='mx-4 flex-1 max-w-xl'>
                            <div className="flex justify-center">
                                <DesktopSelector 
                                    clickHandler={(tab_index) => {
                                        setActiveTabIndex(tab_index);
                                    }} 
                                    tabsData={tabs} 
                                    active={activeTabIndex}
                                    courseKey={subject?.course_key}
                                />
                            </div>
                        </div>
                    )}
                    
                    {/* Right: Empty spacer for symmetry */}
                    <div className='flex-1 flex justify-end'>
                        <div className='w-8'></div>
                    </div>
                </div>
                
                {/* Mobile: Two rows */}
                <div className='xl:hidden px-3 py-2 relative'>
                    {/* Mobile Row 1: Back Button + Title + Basic Navigation */}
                    <div className='flex items-center justify-between gap-2'>
                        {/* Left: Back Button + Title/Author */}
                        <div className='flex items-center gap-2 flex-1 min-w-0'>
                            <button
  className="
    flex items-center gap-2
    text-white
    px-2.5 py-2
    rounded-xl
    bg-white/15 hover:bg-white/25
    border border-white/25
    shadow-sm shadow-black/10
    active:scale-[0.98]
    transition
    focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70
    group
    min-h-[44px]
    whitespace-nowrap
  "
  onClick={() => exerciseHandler(null)}
  title="Back to Library"
  aria-label="Back to Library"
  type="button"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-4 w-4 flex-shrink-0 group-hover:-translate-x-0.5 transition-transform"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10 19l-7-7m0 0l7-7m-7 7h18"
    />
  </svg>

  <span className="text-xs font-semibold leading-none">Back</span>
</button>

                            
                            <div className='min-w-0 truncate'>
                                <h1 
                                    className='font-semibold text-sm text-white truncate leading-none'
                                    title={subject.title}
                                >
                                    {subject.title}
                                </h1>
                                <p 
                                    className='text-xs text-blue-100/80 truncate mt-0.5'
                                    title={`by ${subject.author}`}
                                >
                                    by {subject.author}
                                </p>
                            </div>
                        </div>
                        
                        {/* Right: Mobile prev/next - Only show if multiple parts */}
                        {hasMultipleParts && (
                            <div className='flex items-center gap-1 flex-shrink-0'>
                                <button
                                    className="text-white hover:text-blue-100 p-1 hover:bg-white/20 rounded disabled:opacity-40 transition-colors"
                                    onClick={() => setActiveTabIndex(Math.max(0, activeTabIndex - 1))}
                                    disabled={activeTabIndex === 0}
                                    title="Previous part"
                                >
                                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                    </svg>
                                </button>
                                
                                <div className="text-white text-xs font-medium px-1.5 min-w-[3rem] text-center">
                                    {activeTabIndex + 1}/{tabs.length}
                                </div>
                                
                                <button
                                    className="text-white hover:text-blue-100 p-1 hover:bg-white/20 rounded disabled:opacity-40 transition-colors"
                                    onClick={() => setActiveTabIndex(Math.min(tabs.length - 1, activeTabIndex + 1))}
                                    disabled={activeTabIndex === tabs.length - 1}
                                    title="Next part"
                                >
                                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                </button>
                            </div>
                        )}
                    </div>
                    
                    
                </div>
            </div>
            
            {/* Content Area */}
<div className='flex-1 min-h-0 min-w-0'>                <SnapsWise 
                    key={`${currentScript.file?.file}-${key}`} 
                    subject={subject} 
                    file={currentScript}
                />
            </div>
        </div>
    ) : (
        <div className="flex justify-center items-center min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-100/30">
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 border border-white/40 shadow-lg">
                <div className="text-gray-600 text-lg">Loading your audiobook...</div>
            </div>
        </div>
    );
};

export default Audiobook;